import React from 'react';
import { Game } from './Game';
export const MainGameRoute = () => {
  return /*#__PURE__*/React.createElement(Game, null);
};